<template>
    <div class="tr-list mp-promos">
        <div class="tr-listWrap">
            <template>
                <promotion-preview
                    v-for="(promotion, id) in promotions"
                    class="o-promoPreview--list"
                    :key="`new-${id}`"
                    :preview-type="previewType"
                    :group-id="groupId"
                    :acceptance="acceptance"
                    :promotion="promotion"
                />
            </template>
        </div>
    </div>
</template>

<script>
import PromotionPreview from '@/components/promotions/promotionsPreview/PromotionPreview'

export default {
    props: {
        promotions: {
            type: Array,
            required: true
        },
        setWeight: {
            type: String,
            required: false
        },
        previewType: {
            type: String,
            required: true
        },
        groupId: {
            type: Number,
            required: false,
            default: null
        },
        acceptance: {
            type: String,
            default: ''
        }
    },
    components: {
        PromotionPreview
    }
}
</script>
